import ICalibrationParking = ZoneIQCalibration.ICalibrationParking;
import { BaseMutableModel } from '../common-models/base-mutable-model.model';
import { ICalibrationParkingModel } from 'src/app/interfaces/calibration-parking-model.interface';

export class CalibrationParkingValue extends BaseMutableModel<ICalibrationParkingModel> implements ICalibrationParkingModel {
    public ZoneCombinationId: number;
    public OverlayTypologyId?: number;
    public RevisionId: number;

    public Residential?: number;
    public ResidentialVisitors?: number;
    public ResidentialTODBenefitReduction?: number;
    public LodgingRooms?: number;
    public LodgingVisitors?: number;
    public LodgingTODBenefitReduction?: number;
    public Office?: number;
    public OfficeTODBenefitReduction?: number;
    public Commercial?: number;
    public CommercialTODBenefitReduction?: number;
    public CivicAssembly?: number;
    public CivicTODBenefitReduction?: number;
    public TODMaxDistanceToStation?: any;
    public TODMinDistanceToLowDensity?: any;

    public settings: any = null;

    constructor(data: ICalibrationParking, fieldSettings?: any) {
        super(data, ['ZoneCombinationId', 'OverlayTypologyId'], fieldSettings);
    }

    static factory(data: ICalibrationParking): CalibrationParkingValue {
        return new CalibrationParkingValue(data);
    }
}
